import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M0,-7.5h0.5v7.5h-0.5zM-0.5,0h0.5v0.5h-0.5z' },
    { paint: 'fence', d: 'M-0.5,-7h0.5v7h-0.5z' },
    {
      paint: 'evergreenDark',
      d: 'M-2.5,-8.5h0.5v0.5h-0.5zM-1,-8.5h0.5v0.5h-0.5zM2.5,-8.5h0.5v0.5h-0.5zM-3.5,-8h3v0.5h-3zM1,-8h2.5v0.5h-2.5zM-4,-7.5h1.5v0.5h-1.5zM-2,-7.5h0.5v0.5h-0.5zM2,-7.5h2.5v0.5h-2.5zM3.5,-7h1.5v0.5h-1.5z',
    },
    {
      paint: 'palm',
      d: 'M0,-10.5h0.5v0.5h-0.5zM0,-10h1v0.5h-1zM2.5,-10h1.5v0.5h-1.5zM0.5,-9.5h0.5v0.5h-0.5zM1.5,-9.5h3v0.5h-3zM-4,-9h3v0.5h-3zM0.5,-9h3v0.5h-3zM-2,-8.5h1v0.5h-1zM-0.5,-8.5h0.5v0.5h-0.5zM0.5,-8.5h2v0.5h-2z',
    },
    {
      paint: 'evergreenLight',
      d: 'M-0.5,-10.5h0.5v1h-0.5zM-4,-9.5h3v0.5h-3zM-0.5,-9.5h1v0.5h-1zM-1,-9h1.5v0.5h-1.5zM0,-8.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'beehive',
      d: 'M-0.5,-8h1.5v0.5h-1.5zM-0.5,-7.5h0.5v0.5h-0.5zM0.5,-7.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 107,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M-1.5,-7.5h0.5v4h-0.5zM-1.5,-3.5h1v1h-1zM-1,-2.5h0.5v0.5h-0.5zM-1,-2h1v1h-1zM-0.5,-1h1v1h-1z',
    },
    {
      paint: 'fence',
      d: 'M-2,-7.5h0.5v5h-0.5zM-2,-2.5h1v0.5h-1zM-1.5,-2h0.5v1h-0.5zM-1.5,-1h1v0.5h-1zM-1,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'evergreenDark',
      d: 'M-4,-8.5h0.5v0.5h-0.5zM-2.5,-8.5h0.5v0.5h-0.5zM1,-8.5h0.5v0.5h-0.5zM-5,-8h3v0.5h-3zM-0.5,-8h2.5v0.5h-2.5zM-5.5,-7.5h1.5v0.5h-1.5zM-3.5,-7.5h0.5v0.5h-0.5zM0.5,-7.5h2.5v0.5h-2.5zM2,-7h1v0.5h-1z',
    },
    {
      paint: 'palm',
      d: 'M-1.5,-10.5h0.5v0.5h-0.5zM1,-10h1.5v0.5h-1.5zM-1,-9.5h0.5v0.5h-0.5zM0,-9.5h3v0.5h-3zM-5.5,-9h0.5v0.5h-0.5zM-4.5,-9h2v0.5h-2zM-1,-9h3v0.5h-3zM-3.5,-8.5h1v0.5h-1zM-1,-8.5h2v0.5h-2z',
    },
    {
      paint: 'evergreenLight',
      d: 'M-2,-10.5h0.5v0.5h-0.5zM-2,-10h1v1h-1zM-5.5,-9.5h3v0.5h-3zM-2.5,-9h1.5v0.5h-1.5zM-2,-8.5h1v0.5h-1z',
    },
    { paint: 'beehive', d: 'M-2,-8h1.5v0.5h-1.5zM-1,-7.5h0.5v0.5h-0.5z' },
  ],
  pixels: 111,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'trunk',
      d: 'M1.5,-6h0.5v6h-0.5zM-2.5,-5h0.5v0.5h-0.5zM-3,-4.5h0.5v0.5h-0.5zM-2.5,-3.5h0.5v2h-0.5zM-2.5,-1.5h1v0.5h-1zM-2,-1h0.5v0.5h-0.5zM-2,-0.5h1v0.5h-1zM1,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'fence',
      d: 'M-3,-5h0.5v0.5h-0.5zM1,-5h0.5v5h-0.5zM-3,-4h0.5v3h-0.5zM-2.5,-1h0.5v1h-0.5z',
    },
    {
      paint: 'evergreenDark',
      d: 'M-1,-6.5h2.5v0.5h-2.5zM2.5,-6.5h2v0.5h-2zM-4.5,-6h0.5v0.5h-0.5zM-3.5,-6h0.5v0.5h-0.5zM-1,-6h0.5v0.5h-0.5zM3,-6h2v0.5h-2zM-5.5,-5.5h2.5v0.5h-2.5zM-1.5,-5.5h1.5v0.5h-1.5zM5,-5.5h0.5v0.5h-0.5zM-0.5,-5h0.5v0.5h-0.5z',
    },
    {
      paint: 'palm',
      d: 'M1.5,-8.5h0.5v0.5h-0.5zM2,-8h0.5v0.5h-0.5zM3.5,-8h1.5v0.5h-1.5zM2,-7.5h3v0.5h-3zM-2.5,-7h0.5v0.5h-0.5zM-1.5,-7h3v0.5h-3zM2,-7h2.5v0.5h-2.5zM-5,-6.5h1.5v0.5h-1.5zM-2.5,-6.5h1.5v1h-1.5zM-4,-6h0.5v0.5h-0.5z',
    },
    {
      paint: 'evergreenLight',
      d: 'M1,-8.5h0.5v0.5h-0.5zM-0.5,-8h0.5v0.5h-0.5zM1,-8h1v0.5h-1zM-3,-7.5h0.5v1h-0.5zM-1.5,-7.5h3.5v0.5h-3.5zM-5,-7h1v0.5h-1zM1.5,-7h0.5v0.5h-0.5zM-5.5,-6.5h0.5v0.5h-0.5zM-3.5,-6.5h1v0.5h-1z',
    },
    {
      paint: 'beehive',
      d: 'M1.5,-6.5h1v0.5h-1zM-3,-6h0.5v0.5h-0.5zM2,-6h0.5v0.5h-0.5zM-3,-5.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 128,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
